import axios from './axios'
export default {
//   signup: function(data) {
//     return axios.post('/register', data)
//   },
  login: function(data) {
    return axios.post('/admin/login', data)
  },
//   verifyUser: function(token) {
//     return axios.get(`/user/verify?token=${token}`)
//   },
//   getDetails: function() {
//     return axios.get(`/${process.env.VUE_APP_API_VERSION}/users/me`)
//   },
  logout: function() {
    return axios.post(`/admin/logout`)
  },
//   onboardingComplete: function(data) {
//     return axios.post(`/onboarding/save`, data)
//   },
  getPlans: function(){
    return axios.get(`/api/admin/api/plans`)
  },
  getUsersCount: function(data){
    return axios.get(`/api/admin/api/users/count`, { params: data.query })
  },
  getUsers: function(data) {
    return axios.get(`/api/admin/api/users`, { params: data.query })
  },
  getUserSubscription: function(user_id) {
    return axios.get(`/api/admin/api/users/${user_id}/subscription`)
  },
  editUserSubscription: function(data) {
    return axios.post(`/api/admin/api/users/${data['id']}/subscription`, data)
  },
  addUser: function(data) {
    return axios.post(`/api/admin/users`, data)
  },
//   updateDetails: function(user) {
//     return axios.post(
//       `/${process.env.VUE_APP_API_VERSION}/users/${user.id}`,
//       user
//     )
//   },
  deleteUser: function(id) {
    return axios.delete(`/api/admin/users/${id}`)
  },
//   deleteAccount: function(id, data) {
//     return axios.post(`/${process.env.VUE_APP_API_VERSION}/users/${id}/delete-account`, data)
//   },
//   resetPasswordRequest: function(data) {
//     return axios.post('/password-reset', data)
//   },
  setPassword: function(data) {
    return axios.post('/admin/set-password', data)
  },
//   setAccManagerPassword: function(data) {
//     return axios.post('/set-account-manager-password', data)
//   },
  changePassword: function(id, data) {
    return axios.post(`/admin/users/${id}/change-password`, data)
  },
//   demo: function(data) {
//     return axios.post('/demo')
//   },
//   oauthGrantRequest: function(data) {
//     return axios.post('/oauth/authorize', data)
//   },
  
}
